<template>
  <div id="app">
    <md-toolbar>
      <md-layout class="maxima-header">
        <md-layout>
        </md-layout>

        <md-layout md-align="center">
          <h1 class="md-title">Maxima Online</h1>
        </md-layout>

        <md-layout md-align="end">
          <!-- <div> -->
          <span class="lang-select">
            <md-select name="language" v-model="$language.current">
              <md-option v-for="(language, key) in $language.available" :value="key" :key="key">{{ language }}</md-option>
            </md-select>
          </span>
          <!-- </div> -->
          <span class="welcome-msg">
            <p>{{ welcomeMsg }}</p>
          </span>

          <md-menu md-align-trigger md-size="4" md-direction="bottom left" v-if="loggedIn" ref="mainmenu">
            <md-button class="md-icon-button menu-button" md-menu-trigger>
              <md-icon>more_vert</md-icon>
            </md-button>

            <md-menu-content>
              <md-list>
                <md-list-item v-if="loggedIn && isAdmin && ($route.path === '/orders')">
                  <router-link @click.native="closeMenu()" exact to="/admin">
                    <span>Admin</span><md-icon>security</md-icon>
                  </router-link>
                </md-list-item>
                <md-list-item v-if="loggedIn && isAdmin && ($route.path.includes('/admin'))">
                  <router-link @click.native="closeMenu()" exact to="/orders"><translate>Orders</translate><md-icon>shopping_cart</md-icon></router-link>
                </md-list-item>
                <md-list-item>
                  <router-link @click.native="closeMenu()" exact to="/logout"><translate>Sign-out</translate><md-icon>exit_to_app</md-icon></router-link>
                </md-list-item>
              </md-list>
            </md-menu-content>
          </md-menu>

        </md-layout>
      </md-layout>
    </md-toolbar>

    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMaterial from 'vue-material'
import Css from 'vue-material/dist/vue-material.css'
import auth from './auth'

Vue.use(VueMaterial)

export default {
  name: 'app',
  data () {
    return {
      loggedIn: auth.loggedIn(),
      isAdmin: auth.isAdmin(),
      firstname: auth.getFirstname()
    }
  },
  created () {
    auth.onChange = (loggedIn, idAdmin) => {
      this.loggedIn = loggedIn
      this.isAdmin = idAdmin
    }
  },
  updated () {
    this.firstname = auth.getFirstname()
  },
  computed: {
    welcomeMsg () {
      if (this.loggedIn) {
        return this.$gettext('Welcome ') + this.firstname
      } else {
        return this.$gettext('You are logged out')
      }
    }
  },
  methods: {
    closeMenu () {
      if (this.$refs.mainmenu) {
        this.$refs.mainmenu.close()
      }
    }
  },
  components: {
    Css
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.maxima-header h1 {
  line-height: 48px;
}
button.menu-button {
  margin: 4px !important;
}
.v-enter-active {
  transition: all .2s ease;
}
.v-leave-active {
  transition: all .2s ease;
}
.v-enter, .v-leave-to {
  opacity: 0;
}
.lang-select {
  padding: 8px 16px;
}
.lang-select div.md-select {
  min-width: 60px !important;
}
.welcome-msg p {
  font-size: 16px;
  margin-right: 6px;
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue